import * as React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { Dialog } from "@mui/material";
import List from "@mui/material/List";
import ListItem from "@mui/material/ListItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import ZoomInIcon from "@mui/icons-material/ZoomIn";
import ZoomOutIcon from "@mui/icons-material/ZoomOut";
import { appLogger } from "../../../utils";
import {
  FEEDBACK_TYPE_BUGS,
  FEEDBACK_TYPE_FEATURE_REQ,
  FEEDBACK_TYPE_FEEDBACK,
  PLATFORM_TYPE_MOBILE,
  TYPE_TEXT,
} from "../../../model";

import "./PreviewStyles/index.css";
import { uploadFileBucketName } from "../../../utils/config";

const MobileGeneralPreview = (props: any) => {
  const { productParams } = props;

  const [previewAgent, setPreviewAgent] = React.useState(false);

  const handleTogglePreview = () => {
    setPreviewAgent((prevState) => !prevState);
  };

  const GeneralSettingsTitleFbIcon = (type: any) => {
    let icon = "";
    if (type == "Feedback") {
      if (
        productParams.productParams.products[0].feedbackAgentSettings
          ?.feedbackSettings?.icon
      ) {
        icon =
          productParams.productParams.products[0].feedbackAgentSettings?.feedbackSettings?.icon.startsWith(
            "<svg"
          )
            ? "data:image/svg+xml;base64," +
              window.btoa(
                productParams.productParams.products[0].feedbackAgentSettings
                  ?.feedbackSettings?.icon
              )
            : productParams.productParams.products[0].feedbackAgentSettings
                ?.feedbackSettings?.icon;
      } else {
        icon = `https://${uploadFileBucketName}.s3.amazonaws.com/feedbackIcon.png`;
      }
    }
    if (type == "Bugs") {
      if (
        productParams.productParams.products[0].feedbackAgentSettings
          ?.bugSettings?.icon
      ) {
        icon =
          productParams.productParams.products[0].feedbackAgentSettings?.bugSettings?.icon.startsWith(
            "<svg"
          )
            ? "data:image/svg+xml;base64," +
              window.btoa(
                productParams.productParams.products[0].feedbackAgentSettings
                  ?.bugSettings?.icon
              )
            : productParams.productParams.products[0].feedbackAgentSettings
                ?.bugSettings?.icon;
      } else {
        icon = `https://${uploadFileBucketName}.s3.amazonaws.com/bugIcon.png`;
      }
    }
    if (type == "Freq") {
      if (
        productParams.productParams.products[0].feedbackAgentSettings
          ?.featureReqSettings?.icon
      ) {
        icon = productParams.productParams.products[0].feedbackAgentSettings
          ?.featureReqSettings?.icon
          ? "data:image/svg+xml;base64," +
            window.btoa(
              productParams.productParams.products[0].feedbackAgentSettings
                ?.featureReqSettings?.icon
            )
          : productParams.productParams.products[0].feedbackAgentSettings
              ?.featureReqSettings?.icon;
      } else {
        icon = `https://${uploadFileBucketName}.s3.amazonaws.com/featureIcon.png`;
      }
    }
    return icon;
  };

  const GeneralSettingsMenus = () => {
    appLogger.info({
      infoObj: {
        method: "GeneralSettingsMenus",
        component: "add-product",
        fileName: "GeneralSettingsAgentPreview.tsx",
        productParams: productParams,
      },
    });
    const content: any = [];
    if (
      productParams.productParams.products[0].feedbackAgentSettings?.feedbackTypes.includes(
        FEEDBACK_TYPE_FEEDBACK
      )
    ) {
      content.push(
        <ListItem
          sx={{
            background: "#fff",
            border: "1px solid #dbdce0",
            borderRadius: 2,
            mb: 1,
          }}
        >
          <ListItemIcon>
            <span className="GeneralSettingsTitleFbIcon">
              <img src={GeneralSettingsTitleFbIcon("Feedback")} />
            </span>
            {/* <i className="icon-feedback count-grid-i-icon-fb prev-icon-wrap" /> */}
          </ListItemIcon>
          <Typography className="font-14">
            <ListItemText
              className="agent-gen-text"
              primary={GeneralSettingsTitleFbOption()}
              secondary={GeneralSettingsTitleFbAddiotntooltip()}
            />{" "}
          </Typography>
        </ListItem>
      );
    }
    if (
      productParams.productParams.products[0].feedbackAgentSettings?.feedbackTypes.includes(
        FEEDBACK_TYPE_BUGS
      )
    ) {
      content.push(
        <ListItem
          sx={{
            background: "#fff",
            border: "1px solid #dbdce0",
            borderRadius: 2,
            mb: 1,
          }}
        >
          <ListItemIcon>
            <span className="GeneralSettingsTitleFbIcon">
              <img src={GeneralSettingsTitleFbIcon("Bugs")} />
            </span>
            {/* <i className="icon-bug count-grid-i-icon-bug  prev-icon-wrap" /> */}
          </ListItemIcon>
          <ListItemText
            className="agent-gen-text"
            primary={GeneralSettingsTitleBugOption()}
            secondary={GeneralSettingsTitleBugAddiotntooltip()}
          />
        </ListItem>
      );
    }
    if (
      productParams.productParams.products[0].feedbackAgentSettings?.feedbackTypes.includes(
        FEEDBACK_TYPE_FEATURE_REQ
      )
    ) {
      content.push(
        <ListItem
          sx={{
            background: "#fff",
            border: "1px solid #dbdce0",
            borderRadius: 2,
            mb: 1,
          }}
        >
          <ListItemIcon>
            <span className="GeneralSettingsTitleFbIcon">
              <img src={GeneralSettingsTitleFbIcon("Freq")} />
            </span>
            {/* <i className="icon-feature-request count-grid-i-icon-bug  prev-icon-wrap" /> */}
          </ListItemIcon>
          <ListItemText
            className="agent-gen-text"
            primary={GeneralSettingsTitleFrOption()}
            secondary={GeneralSettingsTitleFrAddiotntooltip()}
          />
        </ListItem>
      );
    }
    return content;
  };

  const GeneralSettingsTitleFbOption = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.title;
  };

  const GeneralSettingsBannerText = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.bannerText;
  };

  const GeneralSettingsTitleFbAddiotntooltip = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.feedbackSettings?.tooltip;
  };
  const GeneralSettingsTitleBugAddiotntooltip = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.bugSettings?.tooltip;
  };
  const GeneralSettingsTitleFrOption = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.title;
  };
  const GeneralSettingsTitleFrAddiotntooltip = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.featureReqSettings?.tooltip;
  };
  const Mainlogo = () => {
    return productParams.productParams.products[0]?.logo;
  };

  const GeneralSettingsMainTitle = () => {
    return productParams.productParams.products[0].feedbackAgentSettings?.title;
  };

  const GeneralSettingsTitleBugOption = () => {
    return productParams.productParams.products[0].feedbackAgentSettings
      ?.bugSettings?.title;
  };

  const renderContent = () => {
    return (
      <Grid
        container
        sx={{
          mt: 1,
          p: 2,
          border: "1px solid #dbdce0",
          borderRadius: "35px",
          padding: "45px 10px 20px 10px",
          background: "#000",
          // boxShadow:
          //   "rgba(60, 64, 67, 0.3) 0px 1px 2px 0px, rgba(60, 64, 67, 0.15) 0px 2px 6px 2px",
        }}
      >
        <Grid
          container
          alignItems="center"
          sx={{
            background: "#0157FF",
            borderRadius: "20px 20px 0 0",
            padding: "10px 12px",
          }}
        >
          <CloseIcon sx={{ color: "#fff", fontSize: "16px" }} />
          <Typography
            sx={{ color: "#fff", fontSize: "13px", marginLeft: "7px" }}
          >
            Feedback
          </Typography>
        </Grid>
        <Grid
          item
          xs={12}
          md={12}
          sx={{
            padding: "10px 12px 0",
            height: previewAgent ? "600px" : "390px",
            overflow: "auto",
            background: "#fff",
            borderRadius: "0 0 15px 15px",
            display: "flex",
            flexDirection: "column",
            "&::-webkit-scrollbar": {
              display: "none",
              "-ms-overflow-style": "none",
              scrollbarWidth: "none",
            },
          }}
        >
          {productParams &&
            productParams.productParams &&
            productParams.productParams.products &&
            productParams.productParams.products[0] &&
            productParams.productParams.products[0].feedbackAgentSettings &&
            productParams.productParams.products[0].feedbackAgentSettings
              .bannerType &&
            productParams.productParams.products[0].feedbackAgentSettings
              .bannerType == TYPE_TEXT && (
              <Typography
                className="preview-info"
                sx={{ textAlign: "center", my: 1.2 }}
                dangerouslySetInnerHTML={{
                  __html: GeneralSettingsBannerText(),
                }}
              >
                {/* {GeneralSettingsBannerText()} */}
              </Typography>
            )}
          <Typography
            className="preview-info"
            sx={{ textAlign: "center", my: 1.2 }}
          >
            {
              productParams.productParams.products[0].feedbackAgentSettings
                .subtitle
            }
          </Typography>
          <List>{GeneralSettingsMenus()}</List>
        </Grid>
      </Grid>
    );
  };

  return (
    <>
      <Typography className="prev-text-titile">
        General Settings: Preview &nbsp;
      </Typography>
      {!previewAgent && (
        <Grid container justifyContent="center" mt={1} mb={1}>
          <Typography
            className="tv-agent-preview-btn guideTourViewActualSize"
            onClick={handleTogglePreview}
            sx={{ color: "#0157FF", fontSize: 12 }}
          >
            Click to preview actual size
          </Typography>
        </Grid>
      )}

      <div style={{ marginTop: "20px" }}>{renderContent()}</div>

      {previewAgent && (
        <Dialog
          open={previewAgent}
          onClose={handleTogglePreview}
          sx={{
            "& .MuiPaper-root": {
              // borderRadius: "20px",
              // maxWidth: "390px",
              // minWidth: "390px",
              // minHeight: "700px",
              // maxHeight: "844px",
              background: "transparent",
              boxShadow: "none",
              "&::-webkit-scrollbar": {
                display: "none",
                "-ms-overflow-style": "none",
                scrollbarWidth: "none",
              },
              overflow: "inherit",
              position: "relative",
            },
            "& .MuiBackdrop-root": {
              backgroundColor: "#808080",
            },
            maxWidth: "390px",
            maxHeight: "844px",
            margin: "auto",
          }}
        >
          {previewAgent && (
            <Typography className="mobile-agent-preview-close">
              For Preview
              <span onClick={handleTogglePreview} className="prevclose">
                &nbsp; x &nbsp;Close&nbsp;
              </span>
            </Typography>
          )}
          {renderContent()}
        </Dialog>
      )}
    </>
  );
};

export default MobileGeneralPreview;
